export default "/images/vendor/@coreui/icons/svg/flag/cif-hn.svg?1a0e993066e0f375a3dcffc9ff01dac3";